import { render, staticRenderFns } from "./AlipayInvoke.vue?vue&type=template&id=13e7047a&scoped=true"
import script from "./AlipayInvoke.vue?vue&type=script&lang=js"
export * from "./AlipayInvoke.vue?vue&type=script&lang=js"
import style0 from "./AlipayInvoke.vue?vue&type=style&index=0&id=13e7047a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e7047a",
  null
  
)

export default component.exports